module.exports = __webpack_public_path__ + "static/media/1_en.e0cddc9c.png";